var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityIncidents(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 10.1253L10.5013 8.00033C10.205 7.7781 9.7976 7.7781 9.5013 8.00033L6.66797 10.1253M11.668 12.2087L10.0013 10.9587L8.33464 12.2087",
    stroke: "#8C8C90",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.18038C2.5 6.51573 2.5 5.1834 2.8146 4.73518C3.12919 4.28695 4.38194 3.85813 6.88743 3.0005L7.36477 2.8371C8.67082 2.39004 9.32384 2.1665 10 2.1665C10.6762 2.1665 11.3292 2.39004 12.6352 2.8371L13.1126 3.0005C15.6181 3.85813 16.8708 4.28695 17.1854 4.73518C17.5 5.1834 17.5 6.51573 17.5 9.18038C17.5 9.58288 17.5 10.0194 17.5 10.4926C17.5 12.5801 16.8027 14.1902 15.8333 15.42M2.6607 12.1665C3.37521 15.7485 6.31368 17.5939 8.2488 18.4392C8.85001 18.7019 9.15062 18.8332 10 18.8332C10.8494 18.8332 11.15 18.7019 11.7512 18.4392C12.233 18.2288 12.777 17.9563 13.3333 17.6105",
    stroke: "#8C8C90",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIncidents);
export default __webpack_public_path__ + "static/media/Security Incidents.260b9db4dd96fd946c9c7756b7b2ac1a.svg";
export { ForwardRef as ReactComponent };